import React from 'react';
import {
  Gallery,
  GalleryItem
} from '@patternfly/react-core';
import { DATA_SOURCE } from '../WizardConstants';
import './Cards.css';
import { useTranslation } from 'localization/useTranslation';
import AssetCard from './Cards/AssetCard';
import ProviderClientCard from './Cards/ProviderClientCard';
import AssetBindingCard from './Cards/AssetBindinCard';


const WizardStepReview = ({ assetInfo, isLoading }) => {
  const T = useTranslation();
  return (
    <div style={{ height: '100%', overflow: 'auto' }}>
      <Gallery hasGutter className={'detail-gallery'}>
        <GalleryItem>
          <AssetCard assetInfo={assetInfo.asset} heading={T.common.asset} isLoading={isLoading} updateAssetInfo={() => {}} />
        </GalleryItem>
        <GalleryItem>
          { (assetInfo.dataSource === DATA_SOURCE.provider)
            && <ProviderClientCard providerClientInfo={assetInfo.providerClient} heading={T.common.provider} isLoading={isLoading} updateProviderClientInfo={() => {}} /> }
        </GalleryItem>
        <GalleryItem>
          { (assetInfo.dataSource === DATA_SOURCE.asset)
            && <AssetBindingCard assetInfo={assetInfo.assetData} heading={'Asset Binding'} isLoading={isLoading} /> }
        </GalleryItem>
      </Gallery>
    </div>
  );
};

export default WizardStepReview;
